import { EssentialItem } from '@/common/utils/get-essentials-data';
import { cn } from '@/shadcn-ui/utils';

interface EssentialsProps {
  essentials: EssentialItem[];
}

export default function Essentials({ essentials }: EssentialsProps) {
  return (
    <div className="flex w-full flex-col items-start justify-between gap-[24px] rounded-[24px] bg-flexcar-grayishBlue p-6 md:gap-[48px] md:rounded-[32px] md:p-12 xl:flex-row">
      <h3 className="pdp-header text-[22px] leading-[32px] md:text-[32px] md:leading-normal">
        Essentials
      </h3>

      <div className="grid w-full grid-cols-1 gap-y-[12px] md:grid-cols-2 md:gap-x-[40px] md:gap-y-[38px] lg:grid-cols-3 xl:w-[984px] xl:gap-x-[72px]">
        {essentials.map(({ title, value }, index) => (
          <div
            key={index}
            className={cn(
              'flex justify-between border-b border-flexcar-neutral70 pb-[12px] md:pb-2',
              {
                'border-none pb-0 md:border-solid md:border-flexcar-neutral70':
                  index === essentials.length - 1,
              }
            )}
          >
            <p className="body2-tight">{title}</p>
            <p className="body2-tight font-semibold">{value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
